export enum DefaultCapexOpexEstNames {
  LABOR = 'PROJECT.FINANCIAL_OPEX.ESTIMATION_DIALOG.ESTIMATION_ITEM_NAMES.LABOR',
  UPGRADING_UNIT = 'PROJECT.FINANCIAL_OPEX.ESTIMATION_DIALOG.ESTIMATION_ITEM_NAMES.UPGRADING_UNIT',
  SERVICES = 'PROJECT.FINANCIAL_OPEX.ESTIMATION_DIALOG.ESTIMATION_ITEM_NAMES.SERVICES',
  INSURANCE = 'PROJECT.FINANCIAL_OPEX.ESTIMATION_DIALOG.ESTIMATION_ITEM_NAMES.INSURANCE',
  TAXES = 'PROJECT.FINANCIAL_OPEX.ESTIMATION_DIALOG.ESTIMATION_ITEM_NAMES.TAXES',
  PH_CONTROL = 'PROJECT.FINANCIAL_OPEX.ESTIMATION_DIALOG.ESTIMATION_ITEM_NAMES.PH_CONTROL',
  OTHER = 'PROJECT.FINANCIAL_OPEX.ESTIMATION_DIALOG.ESTIMATION_ITEM_NAMES.OTHER'
}
